module.exports = __webpack_public_path__ + "img/logost.5ef0d6dc.png";